// extracted by mini-css-extract-plugin
export default {"rateNumber":"FeedbackCard_rateNumber__ZOl+X"};